import { takeEvery, put, call, SagaReturnType } from 'redux-saga/effects';
import { DashboardConstants } from 'src/redux/actions/constant';
import dashboardServices from 'src/services/apiServices/dashboard-services/dashboard-services';

const {
  GET_THERAPIST_DAILY_UPDATES_REQUEST,
  GET_THERAPIST_DAILY_UPDATES_SUCCESS,
  GET_THERAPIST_DAILY_UPDATES_FAILURE,
} = DashboardConstants;

function* getTherapistDailyUpdates(action: any): SagaReturnType<any> {
  try {
    const response = yield call(dashboardServices.getTherapistDailyUpdates, action.payload);
    if (response?.status === 200) {
      yield put({ type: GET_THERAPIST_DAILY_UPDATES_SUCCESS, payload: response });
    }
  } catch (error) {
    yield put({ type: GET_THERAPIST_DAILY_UPDATES_FAILURE, payload: error });
  }
}

function* therapistDailyUpdatesSaga() {
  yield takeEvery(GET_THERAPIST_DAILY_UPDATES_REQUEST, getTherapistDailyUpdates);
}

export default therapistDailyUpdatesSaga;
